import { createWebHistory, createRouter } from "vue-router"
import { useAuthStore } from "@/stores/authStore"
import MainLayout from "@/layouts/MainLayout.vue"
import Schedule from "@/views/Schedule.vue"
import Employees from "@/views/Employees.vue"
import Exchange from "@/views/Exchange.vue"
import Analytics from "@/views/Analytics.vue"
import NotFound from "@/views/NotFound.vue"
import Login from "@/views/Login.vue"
import LoginLayout from "@/layouts/LoginLayout.vue"
import Recovery from "@/views/Recovery.vue"
import Settings from "@/views/Settings.vue"

const routes = [
  {
    path: "/",
    name: 'Home',
    meta: { layout: MainLayout },
    component: Schedule,
  },
  {
    path: "/login",
    name: 'Login',
    meta: { layout: LoginLayout },
    component: Login,
  },
  {
    path: "/recovery",
    name: 'Recovery',
    meta: { layout: LoginLayout },
    component: Recovery,
  },
  {
    path: "/employees",
    name: 'Employees',
    meta: { layout: MainLayout },
    component: Employees,
  },
  {
    path: "/exchange",
    name: 'Exchange',
    meta: { layout: MainLayout },
    component: Exchange,
  },
  {
    path: "/analytics",
    name: 'Analytics',
    meta: { layout: MainLayout },
    component: Analytics,
  },
  {
    path: "/settings",
    name: 'Settings',
    meta: { layout: MainLayout, requiresAdmin: true },
    component: Settings,
  },
  {
    path: "/404",
    name: 'NotFound',
    component: NotFound,
  },
  { path: '/:pathMatch(.*)*', redirect: '/404' }
];

const router = createRouter({
  history: createWebHistory(import.meta.env.VITE_BASE),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  const store = useAuthStore()
  if (!store.permissions) {
    await store.getMyInfo()
  }
  const isAuth = store.isAuth
  const isAdmin = store.permissions?.can_edit_account_settings
  const canViewSchedule = store.permissions?.can_view_schedule_and_timesheet
  const canViewEmployees = store.permissions?.can_view_user_list
  const canViewExchange = store.permissions?.can_view_shift_exchange
  const canViewAnalytics = store.permissions?.can_manage_analytics
  const publicRoutes = ['Login', 'Recovery']
  const allowedRoutes:string[] = []
  const toName = to.name?.toString() || "";

  // Создаем список разрешенных рутов согласно permissions
  const getAllowedRoutes = () => {
    if(canViewSchedule) allowedRoutes.push("Home")
    if(canViewEmployees) allowedRoutes.push("Employees")
    if(canViewExchange) allowedRoutes.push("Exchange")
    if(canViewAnalytics) allowedRoutes.push("Analytics")
    if(isAdmin) allowedRoutes.push("Settings")
    allowedRoutes.push("NotFound")
  }
  getAllowedRoutes()

  // Если пользователь не авторизован и пытается перейти на защищённый маршрут
  if (!isAuth && !publicRoutes.includes(toName)) {
    next({ name: "Login" });
    return;
  }

  // Если пользователь авторизован и пытается зайти на страницу входа
  if (isAuth && toName === "Login") {
    next({ name: "Home" });
    return;
  }

  // Проверка доступа к админ‑маршруту (Settings)
  if (to.meta.requiresAdmin && isAuth && !isAdmin) {
    next({ name: "Home" });
    return;
  }

  if (isAuth) {
    if(allowedRoutes.includes(toName)) {
      next()
    }
      else  {
        next({ name: allowedRoutes[0] })
      }
    return;
  }
  next()
})

export default router;
